import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { JobContextConsumer } from '../../../contexts/JobContext';
import { isEmpty } from '../../../utilities/helperFunctions';
import Pixel, {
    EmitMetric,
} from '../../Analytics/VisibilityPixel/VisibilityPixel';
import HeadingSection from '../../Elements/HeadingSection/HeadingSection';
import { featureCompanyPropType } from '../../Includes/CompanyProps';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';

import './FeaturedCompanyAd.scss';

export class FeaturedCompanyAd extends PureComponent {
    handleAdClick = () => {
        EmitMetric({
            click: 1,
            misc_event_type: 'job-page-company-ad-click',
            company_id:
                this.props.featuredCompany &&
                this.props.featuredCompany.company &&
                this.props.featuredCompany.company.id,
        });
    };

    getFeatureCompanyMetrics = () => ({
        impression: 1,
        misc_event_type: 'job-page-company-ad-impression',
        company_id:
            this.props.featuredCompany &&
            this.props.featuredCompany.company &&
            this.props.featuredCompany.company.id,
    });

    renderLayout = () => {
        const { featuredCompany } = this.props;
        const isFeatureCompanyEmpty =
            isEmpty(featuredCompany) ||
            isEmpty(featuredCompany.headerImage) ||
            isEmpty(featuredCompany.company);

        if (isFeatureCompanyEmpty) {
            return null;
        }

        return (
            <>
                <Pixel metrics={this.getFeatureCompanyMetrics()} />
                <HeadingSection sectionType="heading-section">
                    {() => (
                        <HeadingSection.Heading>
                            featured company
                        </HeadingSection.Heading>
                    )}
                </HeadingSection>
                <div className="company-content">
                    <div className="banner-wrapper">
                        <img
                            className="banner-img"
                            src={buildImagePath(
                                featuredCompany.headerImage.src,
                                'default'
                            )}
                            alt={featuredCompany.headerImage.alt}
                        />
                    </div>
                    <img
                        className="logo"
                        src={buildImagePath(
                            featuredCompany.company.logo.src,
                            'small'
                        )}
                        alt={featuredCompany.company.logo.alt}
                    />
                    <span className="title">{featuredCompany.title}</span>
                    <span className="desc">{featuredCompany.description}</span>
                    <a
                        className="btn"
                        href={featuredCompany.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={this.handleAdClick}
                    >
                        {featuredCompany.buttonText}
                    </a>
                </div>
            </>
        );
    };

    render() {
        const { useCardShell } = this.props;

        return (
            <div className="component-CompanyAds-FeaturedCompanyAd">
                <Pixel metrics={this.getFeatureCompanyMetrics()} />
                {useCardShell ? (
                    <CommonCardShell>{this.renderLayout()}</CommonCardShell>
                ) : (
                    this.renderLayout()
                )}
            </div>
        );
    }
}

export default (props) => (
    <JobContextConsumer>
        {({ featuredCompany }) => (
            <FeaturedCompanyAd {...props} featuredCompany={featuredCompany} />
        )}
    </JobContextConsumer>
);

FeaturedCompanyAd.propTypes = {
    /**
     * meta data for featured company's ads
     */
    featuredCompany: featureCompanyPropType,
    useCardShell: PropTypes.bool,
};

FeaturedCompanyAd.defaultProps = {
    useCardShell: true,
    featuredCompany: {},
};
